import React, { forwardRef, SVGProps } from 'react';

interface TrashIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  width?: number; 
  height?: number; 
}

const TrashIcon = forwardRef<SVGSVGElement, TrashIconProps>(
  ({ color = '#424242', width = 20, height = 20, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        height={height}
        width={width}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M17.2448 4.91058C14.5103 4.6396 11.7594 4.5 9.01674 4.5C7.39084 4.5 5.76494 4.58212 4.13904 4.74635L2.46387 4.91058"
          stroke={color}
          strokeWidth="1.34372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98047 4.07948L7.16112 3.00375C7.29251 2.22365 7.39105 1.64062 8.77881 1.64062H10.9303C12.318 1.64062 12.4248 2.2565 12.548 3.01197L12.7286 4.07948"
          stroke={color}
          strokeWidth="1.34372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4784 7.50781L14.9447 15.7769C14.8544 17.0661 14.7805 18.068 12.4894 18.068H7.21755C4.9265 18.068 4.8526 17.0661 4.76227 15.7769L4.22852 7.50781"
          stroke={color}
          strokeWidth="1.34372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.48242 13.5508H11.2169"
          stroke={color}
          strokeWidth="1.34372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.80078 10.2617H11.9066"
          stroke={color}
          strokeWidth="1.34372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

export default TrashIcon;
